<template>
  <im-window />
</template>

<script>
import ImWindow from "./ImWindow"
export default {
  name: 'Window',
  components: {
    ImWindow
  },
  props: {
  },
  data () {
    return {}
  },
  computed: {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/im/Im.vue